// import React from "react";
// import ReactApexChart from "react-apexcharts";
// import { Box, Typography, Card } from "@mui/material";

// const OrdersPerDayChart = () => {
//   const data = {
//     labels: ["1 Sat", "2 Sun", "3 Mon", "4 Tue", "5 Wed", "6 Thu", "7 Fri"],
//     values: [1, 0, 0, 0, 1, 4, 0]
//   };

//   const options = {
//     chart: {
//       type: "area",
//       toolbar: { show: false },
//       zoom: { enabled: false }
//     },
//     colors: ["#3B82F6"],
//     dataLabels: { enabled: false },
//     stroke: {
//       curve: "smooth",
//       width: 3
//     },
//     fill: {
//       type: "gradient",
//       gradient: {
//         shadeIntensity: 1,
//         opacityFrom: 0.5,
//         opacityTo: 0.1,
//         stops: [0, 90, 100]
//       }
//     },
//     xaxis: {
//       categories: data.labels,
//       labels: {
//         style: {
//           fontSize: "12px",
//           fontWeight: 500
//         }
//       },
//       axisBorder: { show: false },
//       axisTicks: { show: false }
//     },
//     yaxis: {
//       min: 0,
//       title: {
//         text: "Orders",
//         style: { fontSize: "13px", fontWeight: 600 }
//       }
//     },
//     grid: {
//       borderColor: "rgba(0,0,0,0.1)",
//       strokeDashArray: 3
//     },
//     tooltip: {
//       theme: "dark",
//       y: {
//         formatter: val => `${val} orders`
//       }
//     },
//     markers: {
//       size: 5,
//       colors: ["#3B82F6"],
//       strokeWidth: 2,
//       hover: { size: 7 }
//     }
//   };

//   const series = [
//     {
//       name: "Orders per Day",
//       data: data.values
//     }
//   ];

//   return (
//     <Card
//       sx={{
//         p: 3,
//         borderRadius: 4,
//         boxShadow: 3,
//         bgcolor: "background.paper",
//         mt: 4
//       }}
//     >
//       <Typography
//         variant="h5"
//         sx={{
//           fontWeight: 700,
//           textAlign: "center",
//           color: "text.primary",
//           fontFamily: "Mulish, sans-serif",
//           mt: 1
//         }}
//       >
//         Orders Per Day
//       </Typography>

//       <Box>
//         <ReactApexChart
//           options={options}
//           series={series}
//           type="area"
//           height={350}
//         />
//       </Box>
//     </Card>
//   );
// };

// export default OrdersPerDayChart;

import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, Card, CircularProgress, Alert } from "@mui/material";
import { getData } from "../Webservice/Webservice";

const OrdersPerDayChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData("dashboard/chart/orders-trend", null, token);

        if (data && data.success && data.chartData) {
          setChartData(data);
        } else {
          throw new Error("Invalid chart data response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load orders trend chart data");
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Card
        sx={{
          p: 3,
          borderRadius: 4,
          boxShadow: 3,
          bgcolor: "background.paper",
          mt: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 400
        }}
      >
        <CircularProgress />
      </Card>
    );
  }

  // Show error state
  if (error) {
    return (
      <Card
        sx={{
          p: 3,
          borderRadius: 4,
          boxShadow: 3,
          bgcolor: "background.paper",
          mt: 4
        }}
      >
        <Alert severity="error">
          {error}
        </Alert>
      </Card>
    );
  }

  // Show chart when data is available
  if (!chartData) {
    return null;
  }

  const { labels, datasets } = chartData.chartData;
  const dataset = datasets[0];

  const options = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    colors: [dataset.borderColor || "#3B82F6"],
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 3
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.5,
        opacityTo: 0.1,
        stops: [0, 90, 100]
      }
    },
    xaxis: {
      categories: labels,
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500
        }
      },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      min: 0,
      title: {
        text: "Orders",
        style: { fontSize: "13px", fontWeight: 600 }
      }
    },
    grid: {
      borderColor: "rgba(0,0,0,0.1)",
      strokeDashArray: 3
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: val => `${val} orders`
      }
    },
    markers: {
      size: 5,
      colors: [dataset.borderColor || "#3B82F6"],
      strokeWidth: 2,
      hover: { size: 7 }
    }
  };

  const series = [
    {
      name: dataset.label,
      data: dataset.data
    }
  ];

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 4,
        boxShadow: 3,
        bgcolor: "background.paper",
        mt: 4
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textAlign: "center",
          color: "text.primary",
          fontFamily: "Mulish, sans-serif",
          mt: 1
        }}
      >
        Orders Per Day
      </Typography>

      <Box>
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={350}
        />
      </Box>
    </Card>
  );
};

export default OrdersPerDayChart;
